<template>
	<StandardModal
		open
		:title="$t('admin_categories_rename_category_action')"
		:confirmText="$t('common_button_save')"
		:confirmProps="{ disabled: !title || !hasChanged, loading }"
		@confirm="renameCategory"
		@cancel="close"
		small
		ref="modal"
		class="rename-category-modal"
	>
		<div class="modal-wrapper">
			<FormItem :label="$t('admin_categories_category_name_label')">
				<Input v-model="title" autoFocus selectAll />
			</FormItem>
		</div>
	</StandardModal>
</template>

<script>
import { Input, StandardModal, FormItem } from '@/components/common'
import { patch } from '../common'
import { storage } from '@/helpers/utils'

export default {
	name: 'RenameCategoryModal',
	components: { StandardModal, FormItem, Input },
	props: {
		category: Object,
	},
	data() {
		return { title: this.category?.title, loading: false }
	},
	emits: ['success', 'close'],
	computed: {
		trimmedTitle() {
			return this.title?.trim()
		},
		hasChanged() {
			return this.trimmedTitle !== this.category.title
		},
	},
	methods: {
		async renameCategory() {
			this.loading = true
			const payload = {
				title: this.title,
			}
			try {
				const updated = await patch(
					`/organization/categories/${this.category.id}`,
					payload
				)
				storage.set('org_mgmt_changed_categories', true)
				this.$alert.success(
					this.$t('admin_people_changes_saved_confirmation_label')
				)
				this.$emit('success', updated)
				this.close()
			} catch (e) {
				this.loading = false
				if (e.response?.data?.errors?.title) {
					this.$refs.modal.$alert.error(this.$t('apierrors_MISSING_TITLE'))
					return
				}
				this.$refs.modal.$alert.error(this.$t('common_api_error_save'))
			}
		},
		close() {
			this.title = null
			this.$emit('close')
		},
	},
}
</script>

<style lang="scss">
@import 'src/sass/variables';

.rename-category-modal {
	.modal-wrapper {
		padding: 24px;
	}
}
</style>
